import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Layout as DashboardLayout } from "src/layouts/dashboard";

const IndexPage = lazy(() => import("src/pages/dashboard/index"));

const MonitoringPage = lazy(() => import("src/pages/dashboard/monitoring"));
const Statistics = lazy(() => import("src/pages/dashboard/statistics"));
const Documents = lazy(() => import("src/pages/dashboard/documents"));
const Users = lazy(() => import("src/pages/dashboard/users"));
const Settings = lazy(() => import("src/pages/dashboard/settings"));
const Export = lazy(() => import("src/pages/dashboard/export"));
export const dashboardRoutes = [
  {
    path: "dashboard",
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />,
      },
      {
        path: "monitoring",
        element: <MonitoringPage />,
      },
      {
        path: "statistics",
        element: <Statistics />,
      },
      {
        path: "documents",
        element: <Documents />,
      },
      {
        path: "users",
        element: <Users />,
      },
      {
        path:"export",
        element: <Export />,
      },
      {
        path: "settings",
        element: <Settings />,
      },
    ],
  },
];
